import classnames from "classnames";
import React, { useEffect, useState } from "react";
// import { GoogleMap, DirectionsRenderer, useJsApiLoader } from "@react-google-maps/api";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import "leaflet-routing-machine";
import { calculateMidpoint } from "./helpers";

import styles from "./MapCardNew.module.scss";

const Routing = ({ start, end, onRouteReady }) => {
  const map = useMap();
  let routingControl = null; // Keep track of the routing control instance

  useEffect(() => {
    if (!map) return; // Ensure map is defined

    // Remove the previous route if it exists
    if (routingControl) {
      map.removeControl(routingControl);
    }

    // Create custom icons for start and end points
    const startIcon = L.divIcon({
      className: "custom-marker",
      html: '<div class="marker-icon">A</div>',
      iconSize: [30, 30],
      iconAnchor: [15, 30],
    });

    const endIcon = L.divIcon({
      className: "custom-marker",
      html: '<div class="marker-icon">B</div>',
      iconSize: [30, 30],
      iconAnchor: [15, 30],
    });

    // Initialize the new routing control
    routingControl = L.Routing.control({
      waypoints: [L.latLng(start), L.latLng(end)],
      router: L.Routing.osrmv1({
        serviceUrl: "https://router.project-osrm.org/route/v1/",
      }),
      createMarker: (waypoint, index) => {
        const latLng = index.latLng; // Extract latLng from waypoint

        if (waypoint === 0) {
          return L.marker(latLng, { icon: startIcon });
        } else if (waypoint === 1) {
          return L.marker(latLng, { icon: endIcon });
        }
        return null; // Hide intermediate markers
      },
      routeWhileDragging: true,
    }).addTo(map);

    // Notify that the route is ready
    routingControl.on("routesfound", (e) => {
      const routes = e.routes;
      if (routes.length > 0) {
        const route = routes[0];
        if (route && route.bounds && route.bounds.isValid()) {
          map.fitBounds(route.bounds, {
            padding: [50, 50],
            maxZoom: 12,
          });
          onRouteReady(true); // Notify that routing is ready

          // Hide the detailed direction steps after a short delay
          setTimeout(() => {
            const routingContainers = document.querySelectorAll(
              ".leaflet-routing-container",
            );
            routingContainers.forEach((container) => {
              if (container) {
                container.style.display = "none"; // Hide the routing container
              }
            });
          }, 1000);
        } else {
          console.error("Invalid route bounds");
          onRouteReady(false); // Notify that routing failed
        }
      } else {
        console.error("No routes found");
        onRouteReady(false); // Notify that routing failed
      }
    });

    routingControl.on("routeerror", (e) => {
      console.error("Routing error:", e);
      onRouteReady(false); // Notify that routing failed
    });

    // Cleanup function
    return () => {
      if (routingControl) {
        map.removeControl(routingControl); // Remove the route on cleanup
      }
    };
  }, [map, start, end, onRouteReady]); // Track start and end changes

  return null;
};

const MapCardNew = ({ rfqData, loadingClass }) => {
  const [routeReady, setRouteReady] = useState(false);
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const midpoint = calculateMidpoint(start, end);
  useEffect(() => {
    rfqData?.pickUp?.longitude &&
      setStart([rfqData?.pickUp?.latitude, rfqData?.pickUp?.longitude]);
    rfqData?.delivery?.longitude &&
      setEnd([rfqData?.delivery?.latitude, rfqData?.delivery?.longitude]);
    return () => {
      setStart(null);
      setEnd(null);
      setRouteReady(false);
    };
  }, [rfqData]);

  return (
    <>
      {start && end ? (
        <div className={classnames(styles.wrapper, loadingClass)}>
          <MapContainer
            center={midpoint}
            zoom={5}
            style={{ height: "100%", width: "100%" }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Routing
              start={start}
              end={end}
              onRouteReady={setRouteReady} // Pass the state setter function
            />
            {/* {!routeReady && <div className="loading">Loading route...</div>} */}
          </MapContainer>
          <style>
            {`
              .leaflet-right {
                display: none !important;
              };
              .leaflet-pane > svg path.leaflet-interactive {
                stroke: var(--main_color)!important;
              }
              path.leaflet-interactive {
                stroke: var(--main_color)!important;
                stroke-width: 5px !important;
              }
              .custom-marker .marker-icon {
                background-color: red;
                color: white;
                border-radius: 50%;
                text-align: center;
                line-height: 30px;
                width: 30px;
                height: 30px;
                font-size: 16px;
                font-weight: bold;
              }
            `}
          </style>
        </div>
      ) : // <></>)
      null}
    </>
  );
};

export default MapCardNew;
